import { render, staticRenderFns } from "./SgcqSideBar.vue?vue&type=template&id=ae56a2a2&scoped=true"
import script from "./SgcqSideBar.vue?vue&type=script&lang=js"
export * from "./SgcqSideBar.vue?vue&type=script&lang=js"
import style0 from "./SgcqSideBar.vue?vue&type=style&index=0&id=ae56a2a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae56a2a2",
  null
  
)

export default component.exports